import React from "react";
import {useParams} from "react-router";

import {rpAppLink} from "@pg-mono/rp-routes";
import {IOfferFriendlySubFilterGeneralUrlParams} from "@pg-mono/rp-routes";

import {RegionType} from "../../region/types/RegionType";
import {PropertyHouseAdditionalAreas} from "../detail/constants/PropertyHouseAdditionalAreas";
import {PropertyHouseStoreys} from "../detail/constants/PropertyHouseStoreys";
import {PropertyHouseType} from "../detail/constants/PropertyHouseType";
import {offerUrlBuilder} from "../helpers/friendly_offer_list/offer_url_builder";
import {getHouseFilterByOfferListSubType} from "../list/helpers/sub_type/transform/get_house_filter_by_offer_list_sub_type";
import {OfferType} from "../types/OfferType";
import {OfferLocationLinksItem} from "./OfferListLocationLinksItem";

export interface IProps {
    region: {
        name: string;
        name_declension_where: string;
        slug: string;
        type: RegionType;
    };
    offerType: OfferType | null;
    houseStats: {
        properties_houses_detached_count?: number;
        properties_houses_semi_detached_count?: number;
        properties_houses_serial_count?: number;
        properties_houses_single_storey_count?: number;
        properties_houses_additional_areas_attic?: number;
    };
}

type IHouseFilter = ReturnType<typeof getHouseFilterByOfferListSubType>;

const getHouseFilterFromSlug = (offerListSubFilter?: string): IHouseFilter | null => {
    try {
        return offerListSubFilter ? getHouseFilterByOfferListSubType(offerListSubFilter) : null;
    } catch {
        return null;
    }
};

export const OfferLocationLinksRegionHouse = React.memo((props: IProps) => {
    const {region, houseStats} = props;
    const {offerListSubFilter} = useParams<Partial<IOfferFriendlySubFilterGeneralUrlParams>>();

    const houseFilterFromSlug = getHouseFilterFromSlug(offerListSubFilter);

    return (
        <>
            {Object.entries(houseStats).map(([statKey, statValue]) => {
                const link = transformStatIntoLink(statKey, region, houseFilterFromSlug);

                return link && statValue > 0 ? <OfferLocationLinksItem disableSelfLinking linkText={link.text} url={link.href} key={link.href} /> : null;
            })}
        </>
    );
});

const transformStatIntoLink = (fieldName: string, region: IProps["region"], currentHouseFilter?: IHouseFilter | null) => {
    switch (fieldName) {
        case "properties_houses_semi_detached_count": {
            if (
                currentHouseFilter &&
                "house_type" in currentHouseFilter &&
                currentHouseFilter.house_type.toString() === PropertyHouseType.SEMI_DETACHED.toString()
            ) {
                return null;
            }

            const {friendlySlug, offerListSubFilterSlug} = offerUrlBuilder({
                type: OfferType.HOUSE,
                region: region.slug,
                house_type: [PropertyHouseType.SEMI_DETACHED]
            });
            return {
                href: rpAppLink.offer.listFriendlySubFilterGeneral({
                    friendlySlug,
                    offerListSubFilter: offerListSubFilterSlug
                }),
                text: `Bliźniaki ${region.name}`
            };
        }
        case "properties_houses_detached_count": {
            if (
                currentHouseFilter &&
                "house_type" in currentHouseFilter &&
                currentHouseFilter.house_type.toString() === PropertyHouseType.DETACHED.toString()
            ) {
                return null;
            }

            const {friendlySlug, offerListSubFilterSlug} = offerUrlBuilder({
                type: OfferType.HOUSE,
                region: region.slug,
                house_type: [PropertyHouseType.DETACHED]
            });
            return {
                href: rpAppLink.offer.listFriendlySubFilterGeneral({
                    friendlySlug,
                    offerListSubFilter: offerListSubFilterSlug
                }),
                text: `Domy wolnostojące ${region.name}`
            };
        }
        case "properties_houses_serial_count": {
            if (currentHouseFilter && "house_type" in currentHouseFilter && currentHouseFilter.house_type.toString() === PropertyHouseType.SERIAL.toString()) {
                return null;
            }

            const {friendlySlug, offerListSubFilterSlug} = offerUrlBuilder({
                type: OfferType.HOUSE,
                region: region.slug,
                house_type: [PropertyHouseType.SERIAL]
            });
            return {
                href: rpAppLink.offer.listFriendlySubFilterGeneral({
                    friendlySlug,
                    offerListSubFilter: offerListSubFilterSlug
                }),
                text: `Segmenty ${region.name}`
            };
        }
        case "properties_houses_single_storey_count": {
            if (
                currentHouseFilter &&
                "house_storeys" in currentHouseFilter &&
                currentHouseFilter.house_storeys.toString() === PropertyHouseStoreys.SINGLE_STOREY.toString()
            ) {
                return null;
            }

            const {friendlySlug, offerListSubFilterSlug} = offerUrlBuilder({
                type: OfferType.HOUSE,
                region: region.slug,
                house_storeys: [PropertyHouseStoreys.SINGLE_STOREY]
            });
            return {
                href: rpAppLink.offer.listFriendlySubFilterGeneral({
                    friendlySlug,
                    offerListSubFilter: offerListSubFilterSlug
                }),
                text: `Domy parterowe ${region.name}`
            };
        }
        case "properties_houses_additional_areas_attic": {
            if (
                currentHouseFilter &&
                "house_additional_areas" in currentHouseFilter &&
                currentHouseFilter.house_additional_areas.toString() === PropertyHouseAdditionalAreas.ATTIC.toString()
            ) {
                return null;
            }

            const {friendlySlug, offerListSubFilterSlug} = offerUrlBuilder({
                type: OfferType.HOUSE,
                region: region.slug,
                house_additional_areas: [PropertyHouseAdditionalAreas.ATTIC]
            });
            return {
                href: rpAppLink.offer.listFriendlySubFilterGeneral({
                    friendlySlug,
                    offerListSubFilter: offerListSubFilterSlug
                }),
                text: `Domy z poddaszem ${region.name}`
            };
        }
        default:
            return null;
    }
};
import React from "react";
import {useParams} from "react-router";

import {rpAppLink} from "@pg-mono/rp-routes";
import {IOfferFriendlySubFilterGeneralUrlParams} from "@pg-mono/rp-routes";

import {RegionType} from "../../region/types/RegionType";
import {PropertyHouseAdditionalAreas} from "../detail/constants/PropertyHouseAdditionalAreas";
import {PropertyHouseStoreys} from "../detail/constants/PropertyHouseStoreys";
import {PropertyHouseType} from "../detail/constants/PropertyHouseType";
import {offerUrlBuilder} from "../helpers/friendly_offer_list/offer_url_builder";
import {getHouseFilterByOfferListSubType} from "../list/helpers/sub_type/transform/get_house_filter_by_offer_list_sub_type";
import {OfferType} from "../types/OfferType";
import {OfferLocationLinksItem} from "./OfferListLocationLinksItem";

export interface IProps {
    region: {
        name: string;
        name_declension_where: string;
        slug: string;
        type: RegionType;
    };
    offerType: OfferType | null;
    houseStats: {
        properties_houses_detached_count?: number;
        properties_houses_semi_detached_count?: number;
        properties_houses_serial_count?: number;
        properties_houses_single_storey_count?: number;
        properties_houses_additional_areas_attic?: number;
    };
}

type IHouseFilter = ReturnType<typeof getHouseFilterByOfferListSubType>;

const getHouseFilterFromSlug = (offerListSubFilter?: string): IHouseFilter | null => {
    try {
        return offerListSubFilter ? getHouseFilterByOfferListSubType(offerListSubFilter) : null;
    } catch {
        return null;
    }
};

export const OfferLocationLinksRegionHouse = React.memo((props: IProps) => {
    const {region, houseStats} = props;
    const {offerListSubFilter} = useParams<Partial<IOfferFriendlySubFilterGeneralUrlParams>>();

    const houseFilterFromSlug = getHouseFilterFromSlug(offerListSubFilter);

    return (
        <>
            {Object.entries(houseStats).map(([statKey, statValue]) => {
                const link = transformStatIntoLink(statKey, region, houseFilterFromSlug);

                return link && statValue > 0 ? <OfferLocationLinksItem disableSelfLinking linkText={link.text} url={link.href} key={link.href} /> : null;
            })}
        </>
    );
});

const transformStatIntoLink = (fieldName: string, region: IProps["region"], currentHouseFilter?: IHouseFilter | null) => {
    switch (fieldName) {
        case "properties_houses_semi_detached_count": {
            if (
                currentHouseFilter &&
                "house_type" in currentHouseFilter &&
                currentHouseFilter.house_type.toString() === PropertyHouseType.SEMI_DETACHED.toString()
            ) {
                return null;
            }

            const {friendlySlug, offerListSubFilterSlug} = offerUrlBuilder({
                type: OfferType.HOUSE,
                region: region.slug,
                house_type: [PropertyHouseType.SEMI_DETACHED]
            });
            return {
                href: rpAppLink.offer.listFriendlySubFilterGeneral({
                    friendlySlug,
                    offerListSubFilter: offerListSubFilterSlug
                }),
                text: `Bliźniaki ${region.name}`
            };
        }
        case "properties_houses_detached_count": {
            if (
                currentHouseFilter &&
                "house_type" in currentHouseFilter &&
                currentHouseFilter.house_type.toString() === PropertyHouseType.DETACHED.toString()
            ) {
                return null;
            }

            const {friendlySlug, offerListSubFilterSlug} = offerUrlBuilder({
                type: OfferType.HOUSE,
                region: region.slug,
                house_type: [PropertyHouseType.DETACHED]
            });
            return {
                href: rpAppLink.offer.listFriendlySubFilterGeneral({
                    friendlySlug,
                    offerListSubFilter: offerListSubFilterSlug
                }),
                text: `Domy wolnostojące ${region.name}`
            };
        }
        case "properties_houses_serial_count": {
            if (currentHouseFilter && "house_type" in currentHouseFilter && currentHouseFilter.house_type.toString() === PropertyHouseType.SERIAL.toString()) {
                return null;
            }

            const {friendlySlug, offerListSubFilterSlug} = offerUrlBuilder({
                type: OfferType.HOUSE,
                region: region.slug,
                house_type: [PropertyHouseType.SERIAL]
            });
            return {
                href: rpAppLink.offer.listFriendlySubFilterGeneral({
                    friendlySlug,
                    offerListSubFilter: offerListSubFilterSlug
                }),
                text: `Segmenty ${region.name}`
            };
        }
        case "properties_houses_single_storey_count": {
            if (
                currentHouseFilter &&
                "house_storeys" in currentHouseFilter &&
                currentHouseFilter.house_storeys.toString() === PropertyHouseStoreys.SINGLE_STOREY.toString()
            ) {
                return null;
            }

            const {friendlySlug, offerListSubFilterSlug} = offerUrlBuilder({
                type: OfferType.HOUSE,
                region: region.slug,
                house_storeys: [PropertyHouseStoreys.SINGLE_STOREY]
            });
            return {
                href: rpAppLink.offer.listFriendlySubFilterGeneral({
                    friendlySlug,
                    offerListSubFilter: offerListSubFilterSlug
                }),
                text: `Domy parterowe ${region.name}`
            };
        }
        case "properties_houses_additional_areas_attic": {
            if (
                currentHouseFilter &&
                "house_additional_areas" in currentHouseFilter &&
                currentHouseFilter.house_additional_areas.toString() === PropertyHouseAdditionalAreas.ATTIC.toString()
            ) {
                return null;
            }

            const {friendlySlug, offerListSubFilterSlug} = offerUrlBuilder({
                type: OfferType.HOUSE,
                region: region.slug,
                house_additional_areas: [PropertyHouseAdditionalAreas.ATTIC]
            });
            return {
                href: rpAppLink.offer.listFriendlySubFilterGeneral({
                    friendlySlug,
                    offerListSubFilter: offerListSubFilterSlug
                }),
                text: `Domy z poddaszem ${region.name}`
            };
        }
        default:
            return null;
    }
};
